import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';
import { Empty } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { Card } from '@cards/Card';
import { selectAppUser, selectAppUserCallToActions } from '@redux/appUsers/reducers';
import { fetchAppUserCallToActions } from '@redux/appUsers/actions';
import './style.less';

// Add icon libraries for findIconDefinition to work
library.add(fas, far);

function CallToActionList({ appUserId }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [loading, appUser] = useSelector(selectAppUser(appUserId));
  const [callToActionsLoading, callToActions] = useSelector(selectAppUserCallToActions(appUserId));
  const callToActionsForClinicians = callToActions.filter(cta => cta.audience === 'clinician');

  const getIcon = cta => {
    if (cta.icon_url) {
      return <img src={cta.icon_url} alt={cta.name} className="cta-icon-image" />;
    }
    if (cta.icon_name) {
      // Try to find icon in pro-regular first, then pro-solid
      let iconDef = findIconDefinition({ prefix: 'far', iconName: cta.icon_name });
      if (!iconDef) {
        iconDef = findIconDefinition({ prefix: 'fas', iconName: cta.icon_name });
      }
      if (iconDef) {
        return <FontAwesomeIcon icon={iconDef} size="3x" className="cta-icon-fa" />;
      }
    }
    return null;
  };

  useEffect(() => {
    if (appUser && !callToActions && !callToActionsLoading) {
      dispatch(fetchAppUserCallToActions(appUserId));
    }
  }, [dispatch, appUserId, appUser, callToActions, callToActionsLoading]);

  return (
    <Card
      className="call-to-action-list-card"
      loading={loading || callToActionsLoading}
      title={t('cards:CallToActionList.title')}
    >
      {callToActionsForClinicians && callToActionsForClinicians.length > 0 ? (
        <div className="cta-grid">
          {callToActionsForClinicians.map((cta, index) => (
            <button
              key={index}
              className="cta-button"
              onClick={() =>
                history.push(`/patients/individuals/${appUserId}/call-to-action/${index}`)
              }
            >
              <div className="cta-icon">{getIcon(cta)}</div>
              <div className="cta-name">{cta.name}</div>
            </button>
          ))}
        </div>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t('cards:CallToActionList.empty')}
        />
      )}
    </Card>
  );
}

CallToActionList.propTypes = {
  appUserId: string.isRequired,
};

export default CallToActionList;
